var Hoverable = {
  data() {
    return {
      hover: false,
    }
  },
  methods: {
    mouseover() {
      // prevent to set hover again and reload the componennt
      if(!this.hover) {
        this.hover = true
      }
    },
    mouseout() {
      // prevent to set hover again and reload the componennt
      if(this.hover) {
        this.hover = false
      }
    },
  },
}

export default Hoverable;
